import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { AppConfig } from '../config.service';
import { TaskResultGeneric } from '../../models/task-result-generic';
import { UserModel } from '../../models/client-models';

const CHRONO_USER_ENDPOINT = 'User';

@Injectable({
  providedIn: 'root',
})
export class ChronoUserBackendService {
  constructor(private http: HttpClient) {}

  public getUserById(id: number) {
    return this.http.get<TaskResultGeneric<UserModel>>(
      AppConfig.settings.backend.url + CHRONO_USER_ENDPOINT + '/' + id
    );
  }
}
